export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7063.c78e1ae8.jpg";